import { GET_TRIAL_FEATURES, START_TRIAL } from "./actionType";

const initialState = {
    data: null
}

export const trialFeaturesReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case `${GET_TRIAL_FEATURES}_SUCCESS`:
            return {
                ...state,
                data: payload
            };
        default:
            return state;
    }

}

export const isTrialDataLoadingReducer = (state = false, action) => {
    switch(action.type) {
        case START_TRIAL:
            return true;
        case `${START_TRIAL}_FAILED`:
        case `${GET_TRIAL_FEATURES}_SUCCESS`:
            return false;
        default: 
            return state;
    }
}